module.exports = __webpack_public_path__ + "static/media/UN0339383.f711ff9e.jpg";